import LocalHospitalOutlinedIcon from "@mui/icons-material/LocalHospitalOutlined";
import { AdministrationServicePath, HOSPITALITIES } from "utils/constants";
import ListHospitality from "./List";
import CreateHospitality from "./Create";
import EditHospitality from "./Edit";
import ShowHospitality from "./Show";
import permissions from "app/permissions";
import { tenants } from "utils/tenants";

export const resources = {
  isMenu: true,
  tenancies: [tenants.MU],
  icon: <LocalHospitalOutlinedIcon />,
  name: AdministrationServicePath + HOSPITALITIES,
  title: "Болници",
  list: <ListHospitality />,
  create: <CreateHospitality />,
  createPermission: permissions.canManageHospitalities,
  edit: <EditHospitality />,
  editPermission: permissions.canManageHospitalities,
  show: <ShowHospitality />,
  showPermission: permissions.canPreviewHospitalities,
  permission: permissions.canPreviewHospitalities,
};
